import { render, staticRenderFns } from "./MemoryWrapper.vue?vue&type=template&id=5e315efe"
import script from "./MemoryWrapper.vue?vue&type=script&lang=js"
export * from "./MemoryWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports